// Make top-level parent items clickable on desktop by label→URL mapping.
// Dropdowns still open on hover. Mobile untouched.
document.addEventListener('click', function (e) {
  if (!window.matchMedia('(min-width: 990px)').matches) return; // desktop only
  const summary = e.target.closest('summary.header__menu-item');
  if (!summary) return;

  // If user clicked the caret/chevron, let Dawn handle dropdown
  if (e.target.closest('.icon-caret, svg, use')) return;

  // Map parent labels to their target URLs (EDIT urls to match your store)
  const map = {
    'dining': '/collections/dining',
    'decor': '/collections/decor',
    'earthenware': '/collections/earthenware',
    
    
    };

  const label = (summary.textContent || '').trim().toLowerCase();
  let target = '';

  // Find the first key contained in the label
  for (const key in map) {
    if (label.includes(key)) {
      target = map[key];
      break;
    }
  }

  if (target) {
    e.preventDefault();
    window.location.assign(target);
  }
}, true);
